import { render, staticRenderFns } from "./DYGoodAudience.vue?vue&type=template&id=00ef4fea&scoped=true"
import script from "./DYGoodAudience.vue?vue&type=script&lang=js"
export * from "./DYGoodAudience.vue?vue&type=script&lang=js"
import style0 from "./DYGoodAudience.vue?vue&type=style&index=0&id=00ef4fea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ef4fea",
  null
  
)

export default component.exports